class Item {
    constructor (v) {
        this.id = v.id;
        this.name = v.name;
        this.image = v.image ? v.image : 'placeholder.png';
        this.equipable = v.equipable ? v.equipable : false;
        this.consumable = v.consumable ? v.consumable : false;
        this.type = v.type;
    }
}

export default Item;
